var _rect, _text, _rect2, _circle, _path, _text2, _path2, _rect3, _circle2, _circle3, _text3, _rect4, _text4, _rect5, _text5, _rect6, _text6, _rect7, _text7, _path3, _rect8, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentSystemDefinitionConnectedOperatingModelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 560,
    viewBox: "0 0 360 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Connected custom intelligent system model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 558,
    rx: 28,
    fill: "#020B1B",
    stroke: "#2B5A85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 42,
    fill: "#74BDFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "YOUR OPERATION"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 68,
    width: 292,
    height: 62,
    rx: 14,
    fill: "#0B2340",
    stroke: "#1768AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 99,
    r: 15,
    fill: "#087CFF",
    fillOpacity: 0.15,
    stroke: "#087CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h14M65 94v14",
    stroke: "#74BDFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 94,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 91,
    dy: 0
  }, "PEOPLE + PROCESS"), /*#__PURE__*/React.createElement("tspan", {
    x: 91,
    dy: 16
  }, "How the work actually moves"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 130v42",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 173,
    width: 304,
    height: 202,
    rx: 24,
    fill: "#07162B",
    stroke: "#087CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 261,
    r: 66,
    fill: "#07152A",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 261,
    r: 51,
    fill: "none",
    stroke: "#FF2775",
    strokeOpacity: 0.38,
    strokeDasharray: "5 8"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 250,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "CONNECTED"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 21
  }, "INTELLIGENCE"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 21
  }, "LAYER"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 194,
    width: 90,
    height: 48,
    rx: 11,
    fill: "#0D2C50",
    stroke: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 223,
    textAnchor: "middle",
    fill: "#74BDFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "DATA")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 194,
    width: 90,
    height: 48,
    rx: 11,
    fill: "#32142A",
    stroke: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 223,
    textAnchor: "middle",
    fill: "#FF91BA",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "RULES")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 306,
    width: 90,
    height: 48,
    rx: 11,
    fill: "#0D302E",
    stroke: "#30D6A1"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 335,
    textAnchor: "middle",
    fill: "#75F0CA",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "EVIDENCE")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 306,
    width: 90,
    height: 48,
    rx: 11,
    fill: "#302712",
    stroke: "#F4B63D"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 268,
    y: 335,
    textAnchor: "middle",
    fill: "#FFD477",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "DECISIONS")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180 375v38",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 414,
    width: 292,
    height: 112,
    rx: 17,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 444,
    fill: "#30D6A1",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 0
  }, "MEASURABLE OUTPUTS"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 472,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 720,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 0
  }, "Automation \xB7 visibility \xB7 control"), /*#__PURE__*/React.createElement("tspan", {
    x: 58,
    dy: 21
  }, "Faster, evidence-based decisions"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentSystemDefinitionConnectedOperatingModelMobile);
export default __webpack_public_path__ + "static/media/custom-development-system-definition-connected-operating-model-mobile.9a8bf6d8e1082be463f8b5bfb7126162.svg";
export { ForwardRef as ReactComponent };